
//
// Card Detection
//
// Credit to
// http://mel-green.com/2008/11/determine-credit-card-type-with-javascript/
// http://stackoverflow.com/questions/5911236/identify-card-type-from-card-number#answer-5911300
//

var cardTypes = {
  visa_electron: { name: "Visa Electron",          rx: /^(4026|417500|4508|4844|491(3|7))/ },
  visa:          { name: "Visa",                   rx: /^4/ },
  mastercard:    { name: "Mastercard",             rx: /^5[1-5]/ },
  amex:          { name: "AMEX",                   rx: /^3[47]/ },
  discover:      { name: "Discover",               rx: /^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)/ },
  diners:        { name: "Diners",                 rx: /^36/ },
  diners_cb:     { name: "Diners - Carte Blanche", rx: /^30[0-5]/ },
  jcb:           { name: "JCB",                    rx: /^35(2[89]|[3-8][0-9])/ },
};

var testNumbers = [
  '5597502558419431',   // MC
  '4485593130614027',   // Visa
  '342180025274694',    // AMEX
  '6011463476949833',   // Discover
];

function inferCardType (number) {
  for (var key in cardTypes) {
    if (number.replace(/[^\d]/g, '').match(cardTypes[key].rx) !== null) {
      return { key: key, name: cardTypes[key].name };
    }
  }
  return null;
}

function selfTest () {
  for (var i in testNumbers) {
    log("CCValidate::selfTest -", testNumbers[i], '->', inferCardType(testNumbers[i]).key);
  }
}



//
// CC Validate
//
// Check an input to see what kind of credit card it matches.
// Optional: format AAAABBBBCCCCDDDD -> AAAA BBBB CCCC DDDD.
//

module.exports = function CCvalidate ($host, config) {

  // Dom
  var dom = {
    main:  $host,
    input: $('input', $host),
    card:  $('[data-card-indicator]', $host)
  };

  // Functions

  function formatCardNumber (value) {
    var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    var matches = v.match(/\d{4,16}/g);
    var match = matches && matches[0] || '';
    var parts = [];

    for (var i = 0, len = match.length; i < len; i += 4) {
      parts.push(match.substring(i, i+4));
    }

    return (parts.length) ? parts.join(' ') : value;
  }

  function updateDetection (event) {
    var match = inferCardType(dom.input.val());
    if (match) { setCard(match); } else { clearCard(); }
    dom.input.val(formatCardNumber(dom.input.val()));
  }

  function setCard (cardType) {
    dom.card.attr('data-type', cardType.key);
    dom.card.attr('title',     cardType.name);
  }

  function clearCard () {
    dom.card.attr('data-type', null);
    dom.card.attr('title', '');
  }

  // Listeners
  dom.input.on('change blur keyup paste', updateDetection);

  // Init
  updateDetection();


};

